import { useEffect, useState } from "react";
import { api, formatErr } from "@/lib/api";
import { toast } from "sonner";

// Simple hosted-payment-link style flow (no card capture in browser).
// Creates a Stripe PaymentIntent and displays the intent id + status so the client
// can complete payment via the client_secret through a Stripe-hosted flow later.
// This avoids shipping stripe.js in the current build while still using real Stripe.
export default function Deposit() {
  const [funds, setFunds] = useState([]);
  const [f, setF] = useState({ fund_id: "", amount: 25000 });
  const [intent, setIntent] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => { api.get("/funds").then((r) => { setFunds(r.data); setF((x) => ({ ...x, fund_id: r.data[0]?.id || "" })); }); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/client/stripe/intent", { fund_id: f.fund_id, amount: Number(f.amount) });
      setIntent(r.data);
      toast.success("Payment intent created. Amount held for confirmation.");
    } catch (e) { toast.error(formatErr(e)); }
    finally { setBusy(false); }
  };

  return (
    <div className="max-w-2xl">
      <h1 className="text-3xl mb-2">Fund a Subscription</h1>
      <p className="text-sm text-muted-foreground mb-6">
        Create a Stripe payment intent to fund a subscription to a Piplight fund. On successful
        payment, a subscription request is auto-created and enters the admin approval queue.
      </p>
      <form onSubmit={submit} className="surface p-6 space-y-4">
        <label className="block"><span className="kicker text-[10px] block mb-2">Fund</span>
          <select value={f.fund_id} onChange={(e) => setF({...f, fund_id: e.target.value})} data-testid="dep-fund"
            className="w-full bg-secondary border border-border px-3 py-2 text-sm">
            {funds.map((x) => <option key={x.id} value={x.id}>{x.name}</option>)}
          </select></label>
        <label className="block"><span className="kicker text-[10px] block mb-2">Amount (USD)</span>
          <input required type="number" min="10" step="100" value={f.amount} onChange={(e) => setF({...f, amount: e.target.value})}
            className="w-full bg-secondary border border-border px-3 py-2 text-sm font-mono" data-testid="dep-amount" /></label>
        <button data-testid="dep-submit" disabled={busy} className="btn-gold w-full py-3 text-xs uppercase tracking-widest">
          {busy ? "Creating…" : "Create Payment Intent"}
        </button>
      </form>
      {intent && (
        <div className="surface p-6 mt-6" data-testid="dep-intent">
          <div className="kicker mb-2">Payment Intent Created</div>
          <div className="font-mono text-xs text-muted-foreground break-all mb-2">{intent.intent_id}</div>
          <div className="text-sm">Client secret has been issued. Complete the payment through your Stripe-hosted checkout link (integration continues in the next milestone).</div>
        </div>
      )}
    </div>
  );
}
